import produce from "immer";
import { IStoreState } from "../initialStoreState";

import { LoadState } from "../../constants/enums";
import { initialMPOI, initialMPOIState } from "./Mpoi.types";
import { MpoiAction } from ".";
import {
  CLEAR_MPOI_LIST_STATE,
  CLEAR_MPOI_REPORT_LIST_STATE,
  FETCH_MPOI_FAILED,
  FETCH_MPOI_LIST_FAILED,
  FETCH_MPOI_LIST_PROGRESS,
  FETCH_MPOI_LIST_SUCCESS,
  FETCH_MPOI_PROGRESS,
  FETCH_MPOI_REPORT_LIST_FAILED,
  FETCH_MPOI_REPORT_LIST_PROGRESS,
  FETCH_MPOI_REPORT_LIST_SUCCESS,
  FETCH_MPOI_SUCCESS,
} from "./MpoiActions";

export const mpoiReducer = (
  state: IStoreState["mpoi"] = initialMPOIState,
  action: MpoiAction
) => {
  switch (action.type) {
    case FETCH_MPOI_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
      });
      return newState;
    }
    case FETCH_MPOI_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
      });
      return newState;
    }
    case FETCH_MPOI_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
      });
      return newState;
    }
    case FETCH_MPOI_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.mpoiLoading = LoadState.InProgress;
        draftState.mpoi = initialMPOI;
      });
      return newState;
    }
    case FETCH_MPOI_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.mpoiLoading = LoadState.Loaded;
        draftState.mpoi = data;
      });
      return newState;
    }
    case FETCH_MPOI_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.mpoiLoading = LoadState.Failed;
        draftState.mpoi = initialMPOI;
        draftState.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_MPOI_LIST_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.NotLoaded;
        draftState.list = [];
      });
      return newState;
    }
    case FETCH_MPOI_REPORT_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.reportLoading = LoadState.InProgress;
        draftState.reportList = [];
      });
      return newState;
    }
    case FETCH_MPOI_REPORT_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.reportLoading = LoadState.Loaded;
        draftState.reportList = data;
      });
      return newState;
    }
    case FETCH_MPOI_REPORT_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.reportLoading = LoadState.Failed;
        draftState.reportList = [];
      });
      return newState;
    }
    case CLEAR_MPOI_REPORT_LIST_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.reportLoading = LoadState.NotLoaded;
        draftState.reportList = [];
      });
      return newState;
    }
    default: {
      return state;
    }
  }
};
